/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';

$(document).ready(() => {

  document.getElementById("open-mobile-nav").addEventListener("click", (e) => {
    e.preventDefault();
    document.getElementById("mobile-nav-container").style.width = "100%";
  });

  document.getElementById("close-mobile-nav").addEventListener("click", (e) => {
    e.preventDefault();
    document.getElementById("mobile-nav-container").style.width = "0%";
  });

  $('.desktop.nav .dropdown').hover(function() {
    var dropdownMenu = $(this).children('.dropdown-menu');
    $(this).addClass('show');
    dropdownMenu.addClass('show');
  }, function(){
    $(this).removeClass('show');
    let dropdownMenu = $(this).children('.dropdown-menu');
    dropdownMenu.removeClass('show');
  });
});
